const initPresentationTabs = () => {
	document.querySelectorAll('.presentation-tabs a')
		.forEach((tab) => {
			tab.addEventListener('click', function(e) {
				e.preventDefault();
				if ( tab.classList.contains('active') ) return;

				document.querySelectorAll('.presentation-tabs a.active')
					.forEach((tab) => {
						tab.classList.remove('active');
					});
				this.classList.add('active');
				document.querySelectorAll('.presentation-content .sessions.active')
					.forEach((sessions) => {
						sessions.classList.remove('active');
					});
				const activeSessions = document.querySelector( this.getAttribute('href') );
				if ( activeSessions ) {
					activeSessions.classList.add('active');
				}
			});
		});
}

document.addEventListener("DOMContentLoaded", initPresentationTabs);